<h2 mat-dialog-title>{{ data.title ?? 'Create milestone' }}</h2>

<mat-dialog-content>
  <div class="entity-form">
    <mat-form-field>
      <mat-label> Name </mat-label>
      <textarea matInput [formField]="form.Name"></textarea>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Due Date </mat-label>
      <input matInput [matDatepicker]="picker" [formField]="form.DueDate" />
      <mat-hint>DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Status </mat-label>
      <mat-select [formField]="form.Status">
        @for (item of milestoneStatuses; track item[0]) {
          <mat-option [value]="item[0]">{{ item[1] }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Hourly Rate (in selected currency) </mat-label>
      <input matInput [formField]="form.HourlyRate" type="number" stept="0.01" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Value (in selected currency) </mat-label>
      <input matInput type="number" [formField]="form.Value" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Currency </mat-label>
      <mat-select [formField]="form.Currency">
        @for (code of currencies; track code) {
          <mat-option [value]="code">{{ code }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (form.Currency().value() !== 'AUD') {
      <mat-form-field>
        <mat-label> Exchange Rate </mat-label>
        <input matInput type="number" [formField]="form.Rate" />
        <mat-hint> (1 AUD equals ... {{ form.Currency().value() }}) </mat-hint>
      </mat-form-field>
    }

    <mat-form-field>
      <mat-label> Project </mat-label>
      <mat-select [formField]="form.ProjectId">
        @for (item of projects(); track item.Id) {
          <mat-option [value]="item.Id">{{ item.Title }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Purchase Order </mat-label>
      <input matInput type="number" [formField]="form.PurchaseOrder" />
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matMiniFab matTooltip="Save client details" (click)="save()" [disabled]="!form().valid() || pending()">
    <mat-icon>save</mat-icon>
  </button>
</mat-dialog-actions>
@if (pending()) {
  <mat-progress-bar mode="indeterminate" />
}
